var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shop-management" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card", closable: "" },
          on: { "tab-remove": _vm.removeTab },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "门店列表", name: "list", closable: false } },
            [
              _c(
                "div",
                { staticClass: "search-area" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "search-form",
                      attrs: { inline: true, model: _vm.searchForm },
                    },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入店铺名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.storeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "storeName", $$v)
                              },
                              expression: "searchForm.storeName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择店铺", clearable: "" },
                              model: {
                                value: _vm.searchForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "status", $$v)
                                },
                                expression: "searchForm.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "歇业中", value: 0 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "正常营业", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "即将营业", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择地址", clearable: "" },
                              model: {
                                value: _vm.searchForm.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "city", $$v)
                                },
                                expression: "searchForm.city",
                              },
                            },
                            _vm._l(_vm.regionOptions, function (province) {
                              return _c("el-option", {
                                key: province.regionId,
                                attrs: {
                                  label: province.regionName,
                                  value: province.regionId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.getList },
                            },
                            [_vm._v("搜索")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.showExportDialog = true
                            },
                          },
                        },
                        [_vm._v("导出文件")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.syncStore },
                        },
                        [_vm._v("同步门店")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleBatchSetting },
                        },
                        [_vm._v("批量设置")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.handleBatchSettingLog },
                        },
                        [_vm._v("批量设置日志")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("添加门店")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    stripe: "",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "编号", align: "center", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.pagination.total -
                                    (_vm.pagination.page - 1) *
                                      _vm.pagination.limit -
                                    scope.$index
                                ) +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "充值码", align: "center", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-image", {
                              staticClass: "qr-code",
                              attrs: {
                                src: scope.row.rechargeCode,
                                "preview-src-list": [scope.row.rechargeCode],
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "等位预点", align: "center", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-image", {
                              staticClass: "qr-code",
                              attrs: {
                                src: scope.row.preOrderCode,
                                "preview-src-list": [scope.row.preOrderCode],
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "自提码", align: "center", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-image", {
                              staticClass: "qr-code",
                              attrs: {
                                src: scope.row.selfPickupCode,
                                "preview-src-list": [scope.row.selfPickupCode],
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          label: "外卖码",
                          align: "center",
                          width: "60",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    staticClass: "qr-code",
                                    attrs: {
                                      src: scope.row.takeAwayCode,
                                      "preview-src-list": [
                                        scope.row.takeAwayCode,
                                      ],
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3429670641
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "POS/CRM", align: "center", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "time-info" }, [
                              _c("div", { staticClass: "order-time" }, [
                                _vm._v(_vm._s(scope.row.thirdStoreId)),
                                _c("br"),
                                _vm._v(_vm._s(scope.row.thirdShopId)),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "storeName",
                      width: "220",
                      label: "店面名称/公众号",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brandName",
                      label: "品牌",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "city", label: "城市", align: "center" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "storeMobile",
                      width: "220",
                      label: "联系人/电话",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "storeAddress",
                      width: "220",
                      label: "地址",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderMode",
                      label: "点餐模式",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-tag", [
                              _vm._v(
                                _vm._s(
                                  scope.row.orderMode === 1 ? "快餐" : "中餐"
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "微信小程序展示", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-color": "#13ce66",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleWxDisplay(
                                    $event,
                                    scope.row.storeId
                                  )
                                },
                              },
                              model: {
                                value: scope.row.isStop,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "isStop", $$v)
                                },
                                expression: "scope.row.isStop",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "支付宝小程序展示", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-color": "#13ce66",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleAliDisplay(
                                    $event,
                                    scope.row.storeId
                                  )
                                },
                              },
                              model: {
                                value: scope.row.isStopAli,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "isStopAli", $$v)
                                },
                                expression: "scope.row.isStopAli",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.openStatus === 1
                                      ? "success"
                                      : scope.row.openStatus === 2
                                      ? "warning"
                                      : "info",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      scope.row.openStatus === 1
                                        ? "正常营业"
                                        : scope.row.openStatus === 0
                                        ? "歇业中"
                                        : "即将营业"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { label: "是否覆盖", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 0,
                                      "active-color": "#13ce66",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleFullCoverage(
                                          $event,
                                          scope.row.storeId
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.fullCoverage,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "fullCoverage", $$v)
                                      },
                                      expression: "scope.row.fullCoverage",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1834751309
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: "操作",
                      align: "center",
                      width: "280",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "warning", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleBusinessHours(scope.row)
                                  },
                                },
                              },
                              [_vm._v("营业时间")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleBookingTime(scope.row)
                                  },
                                },
                              },
                              [_vm._v("预约时间")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                staticClass: "pagination",
                attrs: {
                  "current-page": _vm.pagination.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pagination.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.editTabs, function (item) {
            return _c(
              "el-tab-pane",
              { key: item.name, attrs: { label: item.title, name: item.name } },
              [
                item.type !== "businessHours" &&
                item.type !== "bookingTime" &&
                item.type !== "batchSetting" &&
                item.type !== "batchSettingLog"
                  ? _c("shop-form", {
                      attrs: { type: item.type, "shop-data": item.shopData },
                      on: {
                        submit: _vm.onSubmit,
                        cancel: function () {
                          return _vm.removeTab(item.name)
                        },
                      },
                    })
                  : item.type === "businessHours"
                  ? _c("business-hours", {
                      attrs: { "shop-data": item.shopData },
                      on: {
                        submit: _vm.onBusinessHoursSubmit,
                        cancel: function () {
                          return _vm.removeTab(item.name)
                        },
                      },
                    })
                  : item.type === "bookingTime"
                  ? _c("booking-time-config", {
                      attrs: { "shop-data": item.shopData },
                      on: {
                        submit: _vm.onBookingTimeSubmit,
                        cancel: function () {
                          return _vm.removeTab(item.name)
                        },
                      },
                    })
                  : item.type === "batchSetting"
                  ? _c("batch-setting", {
                      on: {
                        submit: _vm.onBatchSettingSubmit,
                        cancel: function () {
                          return _vm.removeTab(item.name)
                        },
                      },
                    })
                  : item.type === "batchSettingLog"
                  ? _c("batch-setting-log", {
                      on: {
                        cancel: function () {
                          return _vm.removeTab(item.name)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导出文件",
            visible: _vm.showExportDialog,
            width: "200px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExportDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "export-dialog-content" }, [
            _c(
              "div",
              { staticClass: "export-btn-wrapper" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.exportRechargeCode },
                  },
                  [
                    _c("i", { staticClass: "el-icon-download" }),
                    _vm._v(" 导出充值码\n          "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "export-btn-wrapper" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.exportPreCoded },
                  },
                  [
                    _c("i", { staticClass: "el-icon-download" }),
                    _vm._v(" 导出预点码\n          "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "export-btn-wrapper" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.exportSelfPickupCode },
                  },
                  [
                    _c("i", { staticClass: "el-icon-download" }),
                    _vm._v(" 导出自提码\n          "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            false
              ? _c(
                  "div",
                  { staticClass: "export-btn-wrapper" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.exportTakeawayCode },
                      },
                      [
                        _c("i", { staticClass: "el-icon-download" }),
                        _vm._v(" 导出外卖码\n          "),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "export-btn-wrapper" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.exportInfo } },
                  [
                    _c("i", { staticClass: "el-icon-download" }),
                    _vm._v(" 导出门店信息\n          "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }